import { types as sheets } from '../actions/sheets'
import { types as alerts } from '../actions/alerts'
import { types as ui } from '../actions/ui'

const initialState = {
  contactModal: false,
  manageSidebar: false,
  sheets: [],
  alerts: []
}

export default (state = initialState, action) => {
  switch (action.type) {
    case sheets.PUSH:
      return {...state,
        sheets: [...state.sheets,
          action.sheet
        ]
      }

    case sheets.SET:
      return {...state,
        sheets: [action.sheet]
      }

    case sheets.POP:
      return {...state,
        sheets: [...state.sheets.slice(0, 1)]
      }

    case sheets.CLEAR:
      return {...state, sheets: []}

    case alerts.PUSH:
      return {...state,
        alerts: [...state.alerts,
          {...action.settings, id: new Date(), hidden: false}
        ]
      }

    case ui.CONTACT:
      return {...state,
        contactModal: !state.contactModal
      }

    case ui.MANAGE_SIDEBAR:
      return {...state,
        manageSidebar: !state.manageSidebar
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./app/reducers/ui.js